var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.image
    ? _c("figure", [
        _c("img", {
          staticClass: "c-residence__image",
          attrs: { src: _vm.src, alt: _vm.image.alt, title: _vm.image.title }
        })
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }